"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaContextProvider = exports.Media = exports.mediaStyle = void 0;

var fresnel_1 = require("@artsy/fresnel");

var AppMedia = (0, fresnel_1.createMedia)({
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  }
});
exports.mediaStyle = AppMedia.createMediaStyle();
exports.Media = AppMedia.Media, exports.MediaContextProvider = AppMedia.MediaContextProvider;